import { Injectable } from '@angular/core'
import { Router, CanActivate } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth0: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.auth0.isAuthenticated$.pipe(
      tap((isAuth) => {
        if (!isAuth) {
          this.router.navigate(['/login'])
        }
      }),
    )
  }
}
